// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.danger {
  background-color: var(--ion-color-danger);
}

.warning {
  background-color: var(--ion-color-warning);
}

.primary {
  background-color: var(--ion-color-primary);
}

.success {
  background-color: var(--ion-color-success);
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.5);
}

.dayBox {
  width: 100px;
  height: 100px;
  margin: 10px;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  position: relative;
}

.dayBox p {
  margin: 0;
}

.colorLine {
  position: absolute;
  top: 0px;
  height: 7px;
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/sessions/list-day/list-day.component.scss"],"names":[],"mappings":"AAAA;EACE,yCAAA;AACF;;AAEA;EACE,0CAAA;AACF;;AAEA;EACE,0CAAA;AACF;;AAEA;EACE,0CAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,wCAAA;AACF;;AAGA;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,SAAA;AAAF;;AAGA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,4BAAA;EACA,6BAAA;AAAF","sourcesContent":[".danger {\r\n  background-color: var(--ion-color-danger)\r\n}\r\n\r\n.warning {\r\n  background-color: var(--ion-color-warning)\r\n}\r\n\r\n.primary {\r\n  background-color: var(--ion-color-primary)\r\n}\r\n\r\n.success {\r\n  background-color: var(--ion-color-success)\r\n}\r\n\r\nhr {\r\n  margin-top: 1rem;\r\n  margin-bottom: 1rem;\r\n  border: 0;\r\n  border-top: 1px solid rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n\r\n.dayBox {\r\n  width: 100px;\r\n  height: 100px;\r\n  margin: 10px;\r\n  background-color: white;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 10px;\r\n  position: relative;\r\n}\r\n\r\n.dayBox p {\r\n  margin: 0;\r\n}\r\n\r\n.colorLine {\r\n  position: absolute;\r\n  top: 0px;\r\n  height: 7px;\r\n  width: 100%;\r\n  border-top-left-radius: 10px;\r\n  border-top-right-radius: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
